import BaseButton from "../../../components/ui/BaseButton";
import BaseModal from "../../../components/ui/BaseModal";
import "./style.css";
import { useNavigate } from "react-router-dom";

const CompleteProfileModal = ({
  isProfileCompleted,
  setIsProfileCompleted,
  status,
  authRole = "FREELANCER",
  action,
  submittedMessage = "Your profile is submitted, allow us one-two business days for verification.",
}) => {
  const navigate = useNavigate();

  const blockedMessage = action
    ? `In order to ${action}, please complete your profile.`
    : authRole === "FREELANCER"
      ? "In order to request or counter offer this work order, please complete your profile."
      : "In order to perform this action, please complete your profile.";
  return (
    <BaseModal
      style={{
        width: "450px",
        top: "440px",
      }}
      open={isProfileCompleted}
      close={() => {
        setIsProfileCompleted(false);
      }}
    >
      <div className="container bg-[#F6F6F6]">
        <h6
          className="text-dark border-bottom"
          style={{ marginBottom: "24px", paddingBottom: "4px" }}
        >
          {status === "SUBMITTED" ? "Please Wait for Verification" : "Complete your account setup"}
        </h6>

        <p>
          {status === "SUBMITTED" ? submittedMessage : blockedMessage}
        </p>
      </div>

      <div className="d-flex content-center  bg-white py-6">
        <BaseButton
          className="request-button bg-light"
          style={{
            marginRight: "16px",
            color: "#686868",
            width: "150px",
          }}
          onClick={() => setIsProfileCompleted(false)}
        >
          Cancel
        </BaseButton>

        {status === "SUBMITTED" ? (
          <BaseButton
            loaderSize={24}
            loaderColor="primary"
            className="request-button"
            color="primary"
            style={{
              width: "150px",
            }}
            onClick={() =>
              window.open(
                "mailto:helpdesk@techdomain.com.au?subject=Profile Verification Support&body=Hi, my profile has been submitted and I need assistance with the verification process. Please help.",
              )
            }
          >
            Contact Support
          </BaseButton>
        ) : (
          <BaseButton
            loaderSize={24}
            loaderColor="primary"
            className="request-button"
            color="primary"
            style={{
              width: "150px",
            }}
            onClick={() => {
              navigate("/completeYourProfile");
            }}
          >
            Complete Profile
          </BaseButton>
        )}
      </div>
    </BaseModal>
  );
};

export default CompleteProfileModal;
